import { render, staticRenderFns } from "./TtEvent.vue?vue&type=template&id=3dc28d94"
import script from "./TtEvent.vue?vue&type=script&lang=ts"
export * from "./TtEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports